import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'iframeURL',
    
})
export class IframeURLPipe implements PipeTransform {
  transform(dataURL: string): string {
    let url = dataURL;

    if (url.includes('.youtube')) {
      url = this.youtubeURL(url);
    }

    return url;
  }

  youtubeURL(dataURL: string): string {
    const videoID = dataURL.split('embed/')[1].split('?')[0];
    return 'https://www.youtube-nocookie.com/embed/' + videoID + '?rel=0&autoplay=0';
  }
}
